// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ApplicationLauncherMenuItem } from "../../../components/ApplicationLauncher";
import { ApplicationWindow } from "../../../components/ApplicationWindow";
import { OpenAction } from "./ModuleAction";
import { FeatureDataPrefetch } from "../../Feature/components/FeatureDataPrefetch";
import { jsx as _jsx } from "react/jsx-runtime";
export const ModuleLauncherMenuItem = props => {
  const {
    adresse,
    libelle,
    module,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx(ApplicationWindow, {
    path: adresse,
    "data-sentry-element": "ApplicationWindow",
    "data-sentry-component": "ModuleLauncherMenuItem",
    "data-sentry-source-file": "ModuleLauncherMenuItem.tsx",
    children: ({
      onOpen
    }) => /*#__PURE__*/_jsx(FeatureDataPrefetch, {
      path: adresse,
      children: /*#__PURE__*/_jsx(ApplicationLauncherMenuItem, {
        name: `module.${_.snakeCase(libelle)}`,
        content: libelle,
        actions: [/*#__PURE__*/_jsx(OpenAction, {
          onClick: onOpen
        }, "open")],
        path: adresse,
        offset: module ? 1 : 0,
        link: true
        // eslint-disable-next-line react/jsx-props-no-spreading
        ,
        ...rest
      })
    })
  });
};